import Klima from "./pics/klima.jpg"
import Klima2 from "./pics/klima2.jpg"
import Peć from "./pics/pec.jpg"
import Peć2 from "./pics/pec2.jpg"
import Peć3 from "./pics/pec3.jpg"
import Peć4 from "./pics/pec4.jpg"
import Peć5 from "./pics/pec5.jpg"
import Peć6 from "./pics/pec6.jpg"
import Peć7 from "./pics/pec7.jpg"
import Boiler from "./pics/ekockp.png"
import Boiler2 from "./pics/ekockbp.png"
import TesyBoiler from "./pics/tesyboiler.jpg"
import RadijatorVal from "./pics/radijator.jpg"
import RadijatorLip from "./pics/radijatorlip.jpg"
import RadijatorSol from "./pics/radijatorsol.png"
import RadijatorOr from "./pics/radijatoror.png"
import RadijatorTr from "./pics/radijatortrend.jpg"
import RadijatorAq from "./pics/radijatoraqua.jpg"
import RadVentil1 from "./pics/ventil1.jpg"
import RadVentil2 from "./pics/ventil2.jpg"
import BakreneCijevi from "./pics/bakrenecijevi.jpg"
import IzoliranaCijev1 from "./pics/cijevizolirana.jpg"
import IzoliranaCijev2 from "./pics/cijevizolirana2.jpg"
import IzoliranaCijev3 from "./pics/cijevizolirana3.jpeg"


export const pricingData = [
	{
		title: 'VAIL 1-025 (2,5/2,8kW)',
		price: '3490,99kn/463.95€',
		img: Klima2,
		numAcc: '1000+ računa',
		features: [
			'VAIL 1-025 WNO VANJSKA JEDINICA',
		],
		features2: 	'VAIL 1-025 WNI UNUTARNJA JEDINICA',
		},
		{
			title: 'VAIL 1-030 (3,2/3,4kW)',
			price: '3879,99kn/515.64€',
			img: Klima2,
			numAcc: '1000+ računa',
			features: [
				'VAIL 1-045 WNO VANJSKA JEDINICA',
			],
			features2: 	'VAIL 1-045 WNI UNUTARNJA JEDINICA',
			},
	{
		title: 'VAIL 1-045 (4,6/5,2kW)',
		img: Klima2,
		price: '5499,99kn/730.94€',
		numAcc: '50-100 računa',
		features: [
		'VAIL 1-045 WNO VANJSKA JEDINICA',
	],
	features2: 	'VAIL 1-045 WNI UNUTARNJA JEDINICA',
	},
		{
			title: 'VAIL 8-025 (2,6/2,8kW)',
			price: '3759,99kn/502.35€',
			img: Klima,
			numAcc: '1000+ računa',
			features: [
				'VAIL 8-025 WNO VANJSKA JEDINICA',
			],
			features2: 	'VAIL 8-025 WNI UNUTARNJA JEDINICA',
		},
		{
			title: 'VAIL 8-035 (3,5/3,67kW)',
			price: '4229,99kn/562.16€',
			img: Klima,
			numAcc: '1000+ računa',
			features: [
				'VAIL 8-035 WNO VANJSKA JEDINICA',
			],
			features2: 	'VAIL 8-035 WNI UNUTARNJA JEDINICA',
		},
	{
		title: 'VAIL 8-050 (5,2/5,4kW)',
		price: '6549,99kn/870.48€',
		img: Klima,
		numAcc: '50-1000 računa',
		features: [
			'VAIL 8-050 WNO VANJSKA JEDINICA',
		],
		features2: 	'VAIL 8-050 WNI UNUTARNJA JEDINICA',
	},

	{
		title: 'VAF 8-050 (7,1/8,5kW)',
		price: '9359,99kn/1241.27€',
		img: Klima,
		numAcc: '1000+ računa',
		features: [
			'VAIL 8-050 W2NO VANJSKA JEDINICA',
		],
		features2: 	' VAIL 8-050 WNI 2 UNUTARNJE JEDINICE',
	},
	
	{
		title: 'VAF 8-070 (7,1/8,5kW)',
		price: '10,449kn/1388.78€',
		img: Klima,
		numAcc: '1000+ računa',
		features: [
			'VAIL 8-050 W2NO VANJSKA JEDINICA',
		],
		features2: 	' VAIL 8-050 WNI 2 UNUTARNJE JEDINICE',
	},
	
	
];


export const pricingData2 = [
	{
		title: 'Vaillant bojleri',
		img: Peć,
		numAcc: '50-100 računa',
		features1: ['VU 246/5-3 Pro - 9725,00kn/1290,73€'],
		features2: ['VU 256/5-5 Plus - 9735,00kn/1292,06€'],
		features3: ['VU 30 CS/1-5 Plus - 12415,00kn/1647,75€'],
	},
	{
		title: 'Vaillant spremnici',
		price: '10% sniženje na gotovinsko plaćanje',
		img: Peć3,
		numAcc: '1000+ računa',
		features1: ['50L - 1020,00kn/135,38€'],
		features2: ['80L - 1330,00kn/176,52€'],
		features3: ['100L - 1680,00kn/222,98€'],
	},
	{
		title: 'Tesy bojleri',
		img: TesyBoiler,
		price: '10% sniženje na gotovinsko plaćanje',
		numAcc: '50-100 računa',
		features1: ['50L - 1020,00kn/135,38€'],
		features2: ['80L - 1330,00kn/176,52€'],
		features3: ['100L - 1680,00kn/222,98€'],
	},
	{
		title: 'Tesy Kombi bojleri',
		img: TesyBoiler,
		numAcc: '50-100 računa',
		features1: ['80L Lijevi i Desni - 1570,00kn/208,37€'],
		features2: ['100L Lijevi i Desni  - 1700,00kn/225,63€'],
		features3: ['120L Lijevi i Desni  - 1930,00kn/256,16€'],
		
	},
	{
		title: 'Vaillant Termostat',
		price: '100kn/13€',
		img: Peć6,
		numAcc: '1000+ računa',
		features1: ['VRT 15'],
		features2: ['220V'],
		features3: ['Kompletno modularan!'],
	},
	{
		title: 'Vaillant Ventil Plinski',
		price: '100kn/13€',
		img: Peć7,
		numAcc: '1000+ računa',
		features1: ['3/4'],
		features2: ['Ravni'],
		features3: ['TERM.OSIGURAČ'],
	},
	{
		title: 'Vaillant SPOJNI SET',
		price: '100kn/13€',
		img: Peć4,
		numAcc: '1000+ računa',
		features1: ['VU + VIH 120'],
		features2: ['SA SIGURNOSNOM GRUPOM'],
		features3: ['Jednostavan za implementaciju'],
		
	},
	{
		title: 'Vaillant Dimovod',
		price: '100kn/13€',
		img: Peć5,
		numAcc: '1000+ računa',
		features1: ['60/100'],
		features2: ['KOND.UR'],
		features3: ['Jednostavan za implementaciju'],
	},

];

export const pricingData3 = [
	{
		title: 'EKO-CK P 20kW',
		img: Boiler,
		price: '7600kn/1008,69€ ',
		numAcc: '50-100 računa',
		features: [
			'EKO-CK P predviđeni su za loženje krutim gorivom, peletima, uljem ili plinom.',
		],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	 
	},
	{
		title: 'EKO-CK P 25kW',
		price: '8100kn/1075,05€ ',
		img: Boiler,
		numAcc: '50-500 računa',
		features: [
			'EKO-CK P predviđeni su za loženje krutim gorivom, peletima, uljem ili plinom.'],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	},
	{
		title: 'EKO-CK P 30kW',
		price: '8600kn/1141,42€',
		img: Boiler,
		numAcc: '50-1000 računa',
		features: [
			'EKO-CK P predviđeni su za loženje krutim gorivom, peletima, uljem ili plinom.'

		],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	},

	{
		title: 'EKO-CK P 35kW',
		price: '9300kn/1234,32€',
		img: Boiler,
		numAcc: '1000+ računa',
		features: ['EKO-CK P predviđeni su za loženje krutim gorivom, peletima, uljem ili plinom.'],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	},
	{
		title: 'EKO-CK P 40kW',
		price: '9800kn/1300,68€',
		img: Boiler,
		numAcc: '1000+ računa',
		features: ['EKO-CK P predviđeni su za loženje krutim gorivom, peletima, uljem ili plinom.'],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	},
	{
		title: 'EKO-CK P 50kW',
		price: '10750kn/1426,77€',
		img: Boiler,
		numAcc: '1000+ računa',
		features: ['EKO-CK P predviđeni su za loženje krutim gorivom, peletima, uljem ili plinom.'],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	},
	{
		title: 'EKO-CKB P 20kW',
		price: '11450kn/1519,68€',
		img: Boiler2,
		numAcc: '1000+ računa',
		features: ['Posebnost im je ugrađeni inox bojler potrošne tople vode potopljen u kotlovskoj vodi.'],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	},
	{
		title: 'EKO-CKB P 25kW',
		price: '11950kn/1584,04€',
		img: Boiler2,
		numAcc: '1000+ računa',
		features: ['Posebnost im je ugrađeni inox bojler potrošne tople vode potopljen u kotlovskoj vodi.'],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	},
	{
		title: 'EKO-CKB P 30kW',
		price: '12950kn/1718,76€',
		img: Boiler2,
		numAcc: '1000+ računa',
		features: ['Posebnost im je ugrađeni inox bojler potrošne tople vode potopljen u kotlovskoj vodi.'],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	},
	{
		title: 'EKO-CKB P 35kW',
		price: '13600kn/1805,03€',
		img: Boiler2,
		numAcc: '1000+ računa',
		features: ['Posebnost im je ugrađeni inox bojler potrošne tople vode potopljen u kotlovskoj vodi.'],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	},
	{
		title: 'EKO-CKB P 40kW',
		price: '13950kn/1851,48€',
		img: Boiler2,
		numAcc: '1000+ računa',
		features: ['Posebnost im je ugrađeni inox bojler potrošne tople vode potopljen u kotlovskoj vodi.'],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	},
	{
		title: 'EKO-CKB P 50kW',
		price: '14980kn/1988,19€',
		img: Boiler2,
		numAcc: '1000+ računa',
		features: ['Posebnost im je ugrađeni inox bojler potrošne tople vode potopljen u kotlovskoj vodi.'],
		features2: ['Lako održiv i jednostavan za implementaciju!']
	},
	{
		title: 'SENKO C-20 INOX LUX 2920 Desni 25kW',
		price: '9850kn/1307,23€',
		img: Peć2,
		numAcc: '1000+ računa',
		features: [
			'Štednjak CENTRAL',
		],
		features2: 	'Staklo na vratima ložišta',
	},
	{
		title: 'SENKO C-25 INOX LUX 2880 Desni 25kW',
		price: '10930kn/1450,66€',
		img: Peć2,
		numAcc: '1000+ računa',
		features: [
			'Štednjak CENTRAL',
		],
		features2: 	'Staklo na vratima ložišta',
	},
	{
		title: 'SENKO C-30 INOX LUX 2930 Desni 25kW',
		price: '12600kn/1672,31€',
		img: Peć2,
		numAcc: '1000+ računa',
		features: [
			'Štednjak CENTRAL',
		],
		features2: 	'Staklo na vratima ložišta',
	},
	{
		title: 'SENKO C-35 INOX LUX 2835 Desni 35kW',
		price: '12600kn/1672,31€',
		img: Peć2,
		numAcc: '1000+ računa',
		features: [
			'Štednjak CENTRAL',
		],
		features2: 	'Staklo na vratima ložišta',
	},
];


export const pricingData5 = [
	{
		title: 'Vaillant Radijatori',
		img: RadijatorVal,
		price: 'Cijena ovisna o W',
		numAcc: '50-100 računa',
		features: ['Vaillant RAD 22K (1380W - 4600W)'],
		features2: ['Vaillant RAD 22V (1380W - 4600W)'],
	},
	{
		title: 'Lipovica RAD Solar',
		price: 'Cijena ovisna o W',
		img: RadijatorSol,
		numAcc: '1000+ računa',
		features: ['RAD Solar 350-700 (111W-190W)'],
		features2: ['Odlična budžet opcija'],
	},
	{
		title: 'Lipovica RAD Orion ',
		price: 'Cijena ovisna o W',
		img: RadijatorOr,
		numAcc: '1000+ računa',
		features: ['RAD Orion 350/95-600/95 (113W-185W)'],
		features2: ['Odlična budžet opcija'],
	},
	{
		title: 'Lipovica RAD Plano',
		price: 'Cijena ovisna o W',
		img: RadijatorLip,
		numAcc: '1000+ računa',
		features: ['RAD Plano 350/80-700/80 (109W-188W)'],
		features2: ['Odlična budžet opcija'],
	},
	{
		title: 'Ventil RAD TERM Herz',
		price: '$55.50',
		img: RadVentil1,
		numAcc: '1000+ računa',
		features: ['Ravni set'],
		features2: ['Ravni GP'],
	},
	{
		title: 'Heimeier Kutni set 1/2',
		price: '$55.50',
		img: RadVentil2,
		numAcc: '1000+ računa',
		features: ['(Termoglava, DX, ventil term 1/2)'],
		features2: ['(Prigušnica 1/2 kutna)'],
		
	},
	{
		title: 'RAD Aqua',
		img: RadijatorAq,
		price: 'Cijena ovisna o W',
		numAcc: '50-100 računa',
		features: ['Aqua RAD 575W-917W'],
		features2: ['Ravni -  1200x500 - 1800x600'],}, 
	{
		title: 'RAD Trend',
		img: RadijatorTr,
		price: 'Cijena ovisna o W',
		numAcc: '50-100 računa',
		features: ['Trend RAD 752W-1812W'],
		features2: ['Ravni i Zaobljeni -  730x450 - 1850x600'],}, 
	

];


export const pricingData4 = [
	{
		title: 'VUW' + ' ' + '186/5-3 Pro Kombi Vaillant Kond',
		img: Peć,
		numAcc: '50-100 računa',
		features1: ['Vaillant Ventil Plinski 3/4 Ravni'],
		features2: ['Vaillant Dimovod 60/100 KOND.UR'],
		features3: ['Vaillant VRT 15 TERMOSTAT 220V'],
		features4: ['VUW 256/5-5 - 12415,00kn/1647,75€'],
		price: '9725,00kn/1290,73€',
	},
	{
		title: 'VUW 246/5-3 Pro Kombi Vaillant Kond',
		img: Peć,
		numAcc: '50-100 računa',
		features1: ['Vaillant Ventil Plinski 3/4 Ravni'],
		features2: ['Vaillant Dimovod 60/100 KOND.UR'],
		features3: ['Vaillant VRT 15 TERMOSTAT 220V'],
		price: '9735,00kn/1292,06€',
	},
	{
		title: 'VUW 256/5-5 Pro Kombi Vaillant Kond',
		img: Peć,
		numAcc: '50-100 računa',
		features1: ['Vaillant Ventil Plinski 3/4 Ravni'],
		features2: ['Vaillant Dimovod 60/100 KOND.UR'],
		features3: ['Vaillant VRT 15 TERMOSTAT 220V'],
		price: '12,415,00kn/1647,75€',
	},
]

export const pricingData6 = [
	{
		title: 'CU CIJEVI',
		img: BakreneCijevi,
		price: 'Cijena po količini m',
		numAcc: '50-100 računa',
		features: ['x15 - 33kn/4,38€', ],
		features2: ['x18 - 44,50kn/5,91€'],
		features3: ['x22 - 63,80kn/8,47€'],
		features4: ['x28 - 81,20kn/10,78€'],
	  
	}, 
	{
		title: 'CIJEV ALU-PEX 16*2',
		img: IzoliranaCijev1,
		price: '$7.99',
		numAcc: '50-100 računa',
		features4: ['5,80kn/0,77€'],
		features: ['Comisa izolacija'],
		features2: ['50M kolut'],
		features3: ['Povećana otpornost na temperature'],},
	{
		title: 'CIJEV ALU-PEX 20*2',
		img: IzoliranaCijev1,
		price: '$7.99',
		numAcc: '50-100 računa',
		features4: ['5,80kn/0,77€'],
		features: ['Comisa izolacija'],
		features2: ['50M kolut'],
		features3: ['Povećana otpornost na temperature'],},
	{
		title: 'CIJEV ALU-PEX 26*3',
		img: IzoliranaCijev1,
		price: '$7.99',
		numAcc: '50-100 računa',
		features4: ['5,80kn/0,77€'],
		features: ['Comisa izolacija'],
		features2: ['50M kolut'],
		features3: ['Povećana otpornost na temperature'],},
	{
		title: 'HERZ PE-ERT 16*2',
		img: IzoliranaCijev2,
		price: 'Cijena po količini m',
		numAcc: '50-100 računa',
		features4: ['5,80kn/0,77€'],
		features: ['Cijevi za podno grijanje'],
		features2: ['5 slojne'],
		features3: ['Povećana otpornost na temperature'],

	},

	{
		title: 'HERZ Combitop 30-2 ',
		img: IzoliranaCijev3,
		price: '$7.99',
		numAcc: '50-100 računa',
		features4: ['5,80kn/0,77€'],
		features3: ['1400x800 h=51mm'],
		features2: ['(PAK=6,72 m2, 6kom)'],
		features: ['RASTER'],},
	{
		title: 'HERZ Combitop ND 11',
		img: IzoliranaCijev3,
		price: '$7.99',
		numAcc: '50-100 računa',
		features4: ['5,80kn/0,77€'],
		features: ['RASTER'],
		features2: ['1400x800 h=31mm'],
		features3: ['(PAK=14,56 m2, 13kom)'],},
];

export const pricingData7 = [
	{
		title: 'VAIL 1-045 (4,6/5,2kW)',
		img: Klima2,
		price: '5499,99kn/730.94€',
		numAcc: '50-100 računa',
		features: [
		'VAIL 1-045 WNO VANJSKA JEDINICA',
	],
	features2: 	'VAIL 1-045 WNI UNUTARNJA JEDINICA',
	features3: 	'5499,99kn/730.94€'
	},
	{
		title: 'Tesy Kombi bojleri',
		img: TesyBoiler,
		numAcc: '50-100 računa',
		features: ['80L Lijevi i Desni - 1570,00kn/208,37€'],
		features2: ['100L Lijevi i Desni  - 1700,00kn/225,63€'],
		features3: ['120L Lijevi i Desni  - 1930,00kn/256,16€'],
		
	},
	{
		title: 'VUW Pro Vaillant',
		img: Peć,
		numAcc: '50-100 računa',
		features: ['Vaillant Ventil Plinski 3/4 Ravni'],
		features2: ['Vaillant Dimovod 60/100 KOND.UR'],
		features3: ['Vaillant VRT 15 TERMOSTAT 220V'],
		price: '9735,00kn/1292,06€',
	},
	{
		title: 'RAD Aqua',
		img: RadijatorAq,
		price: 'Cijena ovisna o W',
		numAcc: '50-100 računa',
		features: ['Aqua RAD 575W-917W'],
		features3: ['Premium linija!'],
		features2: ['Ravni -  1200x500 - 1800x600'],}, 
	{
		title: 'RAD Trend',
		img: RadijatorTr,
		price: 'Cijena ovisna o W',
		numAcc: '50-100 računa',
		features: ['Trend RAD 752W-1812W'],
		features3: ['Premium linija!'],
		features2: ['Ravni i Zaobljeni -  730x450 - 1850x600'],}, 
		
		
	{
		title: 'HERZ PE-ERT 16*2',
		img: IzoliranaCijev2,
		price: 'Cijena po količini m',
		numAcc: '50-100 računa',
		features4: ['5,80kn/0,77€'],
		features: ['Cijevi za podno grijanje'],
		features2: ['5 slojne'],
		features3: ['Povećana otpornost na temperature'],

	},
	{
		title: 'Lipovica RAD Orion ',
		price: 'Cijena ovisna o W',
		img: RadijatorOr,
		numAcc: '1000+ računa',
		features: ['RAD Orion 350/95-600/95 (113W-185W)'],
		features2: ['Odlična budžet opcija'],
		features3: ['Premium linija!'],
	},

	{
		title: 'HERZ Combitop 30-2 ',
		img: IzoliranaCijev3,
		price: '$7.99',
		numAcc: '50-100 računa',
		features4: ['5,80kn/0,77€'],
		features3: ['1400x800 h=51mm'],
		features2: ['(PAK=6,72 m2, 6kom)'],
		features: ['RASTER'],},
];